<div class="d-flex align-items-center">
  @for (field of field.fieldGroup; track field.id) {
    <div>
      <formly-field [field]="field"></formly-field>
      @if (showError) {
        <div class="invalid-feedback d-block">
          <formly-validation-message [field]="field"></formly-validation-message>
        </div>
      }
    </div>
  }
</div>
